import type { ApiError } from '~/types';
import { apiEndpoints } from '~/constants';
import type { PartnerConfigModel } from '~/types/branding/partner-config';
import useApiService from './useApiService';

export default function useBrandingApi() {
  const config = useRuntimeConfig();
  const brandingRepositoryUrl =
    localStorage.getItem('brandingRepositoryUrl') ?? config.public.s3Bucket;
  const { loadArray } = storeToRefs(useStore());
  const { post } = useApiService();

  const getConfigFromS3 = async (partnerName: string) => {
    loadArray.value.push('getConfigFromS3');
    return await fetch(
      `${brandingRepositoryUrl}partners/${partnerName.toLowerCase()}/config.json`,
      {
        cache: 'no-cache'
      }
    );
  };

  const getBrandingLogos = async (partnerName: string, logo: string, url?: string) => {
    if (!loadArray.value.includes('getLogosFromS3')) loadArray.value.push('getLogosFromS3');
    return await fetch(
      url || `${brandingRepositoryUrl}partners/${partnerName.toLowerCase()}/${logo}`,
      {
        cache: 'no-cache'
      }
    );
  };

  const postBrandingConfig = async (body: PartnerConfigModel) => {
    const { error } = await post(`${apiEndpoints.branding}/config`, body, 'uploadBrandingConfig');

    if (error.value) {
      const cause = error.value.cause as ApiError;
      throw new Error(cause.Message);
    }
  };

  return {
    getConfigFromS3,
    getBrandingLogos,
    postBrandingConfig
  };
}
